import { render, staticRenderFns } from "./DelClassRoom.vue?vue&type=template&id=996519fa&scoped=true&"
import script from "./DelClassRoom.vue?vue&type=script&lang=js&"
export * from "./DelClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./DelClassRoom.vue?vue&type=style&index=0&id=996519fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996519fa",
  null
  
)

export default component.exports